import FaqLayout from "@/components/feature/FaqLayout";

export default function NotReceivedPage() {
  return (
    <FaqLayout
      breadcrumb="/ Subscription Management"
      title="Product or service"
      accent="not received?"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">What to Do When Delivery Is Delayed</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If you have not received your product or service within the expected timeframe, there are several steps you can take before escalating to a formal dispute. Most delivery issues are resolved quickly through our support channels.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Initial Checks</h3>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li>Verify that the email address on your account is correct and check your spam or junk folder.</li>
          <li>Confirm the purchase was successful by reviewing your order confirmation email.</li>
          <li>For physical products, verify the shipping address in your account settings.</li>
          <li>Allow up to <strong>24 hours</strong> for digital services to activate after purchase.</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">When to Contact Support</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If you have completed the initial checks and still have not received your product or service after the following timeframes, please contact our support team:
        </p>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563] mt-3">
          <li><strong>Digital products/services:</strong> 24 hours after purchase</li>
          <li><strong>Standard shipping (UK):</strong> 5 business days after dispatch</li>
          <li><strong>Standard shipping (International):</strong> 10 business days after dispatch</li>
          <li><strong>Express shipping:</strong> 2 business days after dispatch</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Resolution Process</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Our team will investigate your case within 24 hours of receiving your inquiry. If the product or service cannot be delivered, we will issue a full refund to your original payment method within 5 to 10 business days.
        </p>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Urgent delivery issue?</p>
          <p className="text-sm text-[#6C7278]">
            For time-sensitive matters, please submit a support request with your order ID and we will prioritize your case.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}